import { create } from 'zustand';
import { attributedManifestUrl } from '../lib/attributionHandoff.ts';
type BrandState={images:Record<string,{url:string}>;showOnlineCount:boolean;cacheVersion:string;apk:{url?:string;versionName?:string}};
export const useBrandStore=create<BrandState>(()=>({images:{},showOnlineCount:true,cacheVersion:'v1',apk:{}}));
export async function refreshBrandConfig(){
  try{
    const response=await fetch('/api/brand/config',{cache:'no-store'});if(!response.ok)return;
    const data=await response.json();const config=data.config;
    if(!config||typeof config.showOnlineCount!=='boolean')return;
    useBrandStore.setState({images:config.images||{},showOnlineCount:config.showOnlineCount,cacheVersion:config.cacheVersion||'v1',apk:data.apk||{}});
    document.documentElement.dataset.showOnlineCount=String(config.showOnlineCount);
    const manifest=document.querySelector<HTMLLinkElement>('link[rel="manifest"]');
    if(manifest){let savedClick:string|null=null;try{savedClick=localStorage.getItem('sorteia:attributionClickId');}catch{}const href=attributedManifestUrl(config.cacheVersion||'v1',typeof location==='undefined'?'':location.search,savedClick);if(manifest.getAttribute('href')!==href)manifest.href=href;}
  }catch{/* Static identity remains available while the config service is unavailable. */}
}
let started=false;
export function startBrandConfig(){
  if(started)return;started=true;void refreshBrandConfig();
  window.addEventListener('focus',()=>void refreshBrandConfig());
  window.setInterval(()=>{if(document.visibilityState==='visible')void refreshBrandConfig();},60000);
}
